export const SET = "SET";
export const ADD = "ADD";
export const REMOVE = "REMOVE";
export const UPDATE = "UPDATE";
export const MODAL = "MODAL";
export const REFRESH = "REFRESH";
